import { render, staticRenderFns } from "./PoliticaPrivacidad.vue?vue&type=template&id=237397be"
import script from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidad.vue?vue&type=script&lang=js"
import style0 from "./PoliticaPrivacidad.vue?vue&type=style&index=0&id=237397be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports